// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"6889ebff","242":"80518c7a","413":"dc4efbe4","578":"156da00e","787":"52f8f36b","921":"ea3828b6"}[chunkId] + ".chunk.js";
};